import { render, staticRenderFns } from "./ChatPrivateSide.vue?vue&type=template&id=4314bbd1&scoped=true"
import script from "./ChatPrivateSide.vue?vue&type=script&lang=js"
export * from "./ChatPrivateSide.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateSide.vue?vue&type=style&index=0&id=4314bbd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314bbd1",
  null
  
)

export default component.exports